import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import 'nprogress/nprogress.css';
import App from 'src/App';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import * as serviceWorker from 'src/serviceWorker';

import { Amplify, Hub } from 'aws-amplify';
import { AlertProvider } from './contexts/AlertContext';
import { TimeRangeProvider } from './contexts/TimeRangeContenxt';
import { DataSourceProvider } from './contexts/DataSourceContext';

console.log('[Amplify config]', {
  userPoolId: process.env.REACT_APP_USER_POOL_ID,
  clientId: process.env.REACT_APP_WEB_CLIENT_ID,
  domain: process.env.REACT_APP_DOMAIN,
  redirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI,
  apiUrl: process.env.REACT_APP_API_URL
});

Amplify.configure({
  aws_project_region: 'us-west-2',
  aws_cloud_logic_custom: [
    {
      name: 'csweb-dashboard-api',
      endpoint:
        process.env?.REACT_APP_API_URL ||
        'https://141c1bdi3g.execute-api.us-west-2.amazonaws.com/v1/',
      region: 'us-west-2'
    }
  ],
  aws_cognito_region: 'us-west-2',
  aws_user_pools_id: process.env.REACT_APP_USER_POOL_ID,
  aws_user_pools_web_client_id: process.env.REACT_APP_WEB_CLIENT_ID,
  oauth: {
    domain: process.env.REACT_APP_DOMAIN,
    scope: ['email', 'openid', 'profile'],
    redirectSignIn: process.env.REACT_APP_AUTH_REDIRECT_URI,
    redirectSignOut: process.env.REACT_APP_AUTH_REDIRECT_URI,
    responseType: 'code'
  },
  aws_cognito_mfa_configuration: 'OFF'
});

// Register before ReactDOM.render so no auth events are missed during token exchange
Hub.listen('auth', ({ payload: { event, data } }) => {
  console.log('[Hub auth event - global]', event, data);
});

ReactDOM.render(
  <HelmetProvider>
    <SidebarProvider>
      <AlertProvider>
        <TimeRangeProvider>
          <DataSourceProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </DataSourceProvider>
        </TimeRangeProvider>
      </AlertProvider>
    </SidebarProvider>
  </HelmetProvider>,
  document.getElementById('root')
);

serviceWorker.unregister();
